import { render, staticRenderFns } from "./NominasSidebar.vue?vue&type=template&id=01d84ae3&"
import script from "./NominasSidebar.vue?vue&type=script&lang=js&"
export * from "./NominasSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports